import React from "react";
import { Col, Row } from "antd";

const Bone = ({ className = "" }) => (
  <div className={`home-skeleton__bone ${className}`.trim()} aria-hidden="true" />
);

export const BannerSkeleton = () => (
  <div className="slide_banner">
    <Bone className="home-skeleton__banner" />
  </div>
);

export const FeaturedNewsSkeleton = () => (
  <div className="blockNews_container home-skeleton__featured">
    <Bone className="home-skeleton__featured-image" />
    <div className="home-skeleton__featured-content">
      <Bone className="home-skeleton__featured-title" />
      <Bone className="home-skeleton__featured-line" />
      <Bone className="home-skeleton__featured-line" />
      <Bone className="home-skeleton__featured-line home-skeleton__featured-line--short" />
      <Bone className="home-skeleton__featured-date" />
      <Bone className="home-skeleton__featured-button" />
    </div>
  </div>
);

export const CardGridSkeleton = ({
  count = 8,
  colProps = { xs: 24, sm: 12, md: 12, lg: 8, xl: 6 },
  variant = "imageTitle",
}) => {
  const items = Array.from({ length: count });
  const imageClass =
    variant === "imageTitleCtaClub"
      ? "home-skeleton__card-image home-skeleton__card-image--club"
      : variant === "imageTitleCta"
      ? "home-skeleton__card-image home-skeleton__card-image--tall"
      : "home-skeleton__card-image";

  return (
    <Row gutter={[{ xs: 8, lg: 16, sm: 16, xl: 24, md: 16, xxl: 24 }, 24]}>
      {items.map((_, index) => (
        <Col {...colProps} key={index}>
          <div className="home-skeleton__card">
            <Bone className={imageClass} />
            <Bone className="home-skeleton__card-title" />
            {variant === "imageTitle" ? (
              <Bone className="home-skeleton__card-date" />
            ) : (
              <Bone className="home-skeleton__card-button" />
            )}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export const LibraryGridSkeleton = ({ count = 8 }) => {
  const items = Array.from({ length: count });

  return (
    <div className="content-main content-main-image row">
      {items.map((_, index) => (
        <div
          key={index}
          className="col-12 col-sm-6 col-md-4 col-xl-3"
        >
          <Bone className="home-skeleton__library-item" />
        </div>
      ))}
    </div>
  );
};
